// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cgd1Y","label":"styles_label__1XQ0G"};